































// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import { AloCommande, getDefaultAloCommande } from '@/models/alo/AloCommande'
import { VuetifyConfirmObject } from 'vuetify-confirm'
import { StatusCommande } from '@/enum/StatusCommande'

@Component({
  name: 'OrderList',
  props:{
    commandes:Array,
    time:{
      type:Date,
      default:() => new Date()
    },
    loading:{
      type:Boolean,
      default:false
    }
  }
})
export default class OrderList extends Vue {
  private loading!:boolean
  private commandes!:Array<AloCommande>  
  inTime!:boolean

  private get headers(){ return [        
      { text: 'Chambres', value: 'sejour.chambres'},    
      { text: 'Type', value: 'type'},    
      { text: 'Status', value: 'panStatus'},              
      { text: 'Heure Livraison souhaitée', value: 'panDatlivraison' },    
      { text: 'Tarif', value: 'panMontant' }
    ]  
  }
  
  private get search(){
    return this.$store.myGetters.searchCommande
  }
  
  private get sortDesc(){
    return this.$store.myGetters.sortCommandeDesc
  }
  private set sortDesc(value){
    this.$store.myActions.UI_SET_SORT_COMMANDE_DESC(value)
  }

  private get sortBy(){
    return this.$store.myGetters.sortCommandeBy
  }
  private set sortBy(value){
    this.$store.myActions.UI_SET_SORT_COMMANDE_BY(value)
  }

  private get panStatusDic(){
    return this.$store.myGetters.panStatusDic
  } 


    
  created() {    
    this.$store.myActions.ADM_PAN_STATUS_ENSURE()       
  }


  
  openDetail(item: any) {
    this.$router.push({name:'DetailHistory',params:{commandeId:item.id}})    
  }

  deleteCommande(commande:AloCommande) {
     if(commande.id != 0) {      
       this.$confirm(`${this.$t('Commande.AlertDelete')} "${commande.libelle}" ?`,{title: this.$t('Global.Warning')} as VuetifyConfirmObject).then((answer) => {
        if (answer) {          
          this.$store.myActions.ADM_COMMANDE_DELETE_REQUEST(commande.id)
        } 
      })          
    } 
  }
 
}
